// extracted by mini-css-extract-plugin
export default {"root":"DwEw8S","button":"orRXFl"};